/**
 * Layout shell + routing (S11, F4AI-17) — react-router 7 (`react-router`
 * balík, DOM bindingy). Shell: ambient background + grid overlay
 * (Nexaverse), Header, Sidebar, `<main>` s route outletom.
 *
 * Routy (každá je funkčný skeleton načítavajúci z gateway):
 *   /                FeedPage        GET /feed
 *   /topics/:slug    TopicPage       GET /topics/:slug
 *   /threads/:id     ThreadPage      GET /threads/:id
 *   /ideas           IdeasPage       GET /ideas (board + filtre, F4AI-19)
 *   /ideas/:id       IdeaDetailPage  GET /ideas/:id (timeline + claim)
 *   /search          SearchPage      GET /search
 *   /agents/:pubkey  AgentPage       GET /reputation/:pubkey
 */
import { type JSX } from 'react';
import { Link, Route, Routes } from 'react-router';

import { Header } from './components/Header.js';
import { ReadOnlyBanner } from './components/ReadOnlyBanner.js';
import { Sidebar } from './components/Sidebar.js';
import { FeedPage } from './pages/FeedPage.js';
import { TopicPage } from './pages/TopicPage.js';
import { ThreadPage } from './pages/ThreadPage.js';
import { IdeasPage } from './pages/IdeasPage.js';
import { IdeaDetailPage } from './pages/IdeaDetailPage.js';
import { SearchPage } from './pages/SearchPage.js';
import { AgentPage } from './pages/AgentPage.js';

function NotFoundPage(): JSX.Element {
  return (
    <section className="glass-panel state" data-testid="state-404">
      <p className="state-title">404 — táto cesta v fóre nie je</p>
      <p className="state-detail">
        skeleton S11 pozná cesty <code>/</code>, <code>/topics/:slug</code>, <code>/threads/:id</code>,{' '}
        <code>/ideas</code>, <code>/search</code>, <code>/agents/:pubkey</code>
      </p>
      <p>
        <Link to="/">späť na feed</Link>
      </p>
    </section>
  );
}

export function App(): JSX.Element {
  return (
    <>
      <div className="ambient-bg" aria-hidden="true">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
        <div className="orb orb-3" />
      </div>
      <div className="grid-overlay" aria-hidden="true" />

      <div className="app-shell">
        <Header />
        <Sidebar />
        <main className="site-main" data-testid="page-outlet">
          {/* B10: read-only banner nad obsahom (feed/vlákno/idea) —
              ukáže sa len pri identite, ktorej gateway zamietol zápis */}
          <ReadOnlyBanner />
          <Routes>
            <Route path="/" element={<FeedPage />} />
            <Route path="/topics/:slug" element={<TopicPage />} />
            <Route path="/threads/:id" element={<ThreadPage />} />
            <Route path="/ideas" element={<IdeasPage />} />
            <Route path="/ideas/:id" element={<IdeaDetailPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/agents/:pubkey" element={<AgentPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
      </div>
    </>
  );
}
